import React, { useState } from "react";
import { Link } from "react-router-dom";
import Contimg01 from "../../assets/images/about/caprim-equipo.jpg";

// ID del formulario en Formspree. Los mensajes llegan a gerencia@caprimtech.com.
const FORMSPREE_ID = "xjgnjqov";

const LINKEDIN = "https://www.linkedin.com/company/caprim-tech-sas/";
const WHATSAPP =
  "https://wa.me/573025607764?text=Hola,%20quiero%20conocer%20m%C3%A1s%20sobre%20los%20servicios%20de%20Caprim";

// El formulario se divide en tres pasos. Pedir dos o tres datos por
// pantalla en lugar de seis de golpe sube la tasa de envio: el
// visitante siempre ve un tramo corto y no una pared de campos.
const PASOS = [
  { titulo: "Empecemos", ayuda: "Cuéntanos quién eres." },
  { titulo: "Cómo te contactamos", ayuda: "Para responderte por donde prefieras y entender mejor tu empresa." },
  { titulo: "Tu mensaje", ayuda: "Y listo, nosotros seguimos desde aquí." },
];

const SIGUIENTES = [
  { n: "1", t: "Recibimos tu mensaje", d: "Te llega una confirmación al correo" },
  { n: "2", t: "Te contactamos", d: "Dentro del siguiente día hábil" },
  { n: "3", t: "Resolvemos tu caso", d: "Te acompañamos a elegir la solución" },
];

const Contact = () => {
  const [paso, setPaso] = useState(0);
  const [estado, setEstado] = useState("inicial");
  const [aviso, setAviso] = useState("");
  const [datos, setDatos] = useState({
    nombre: "",
    email: "",
    telefono: "",
    interes: "",
    ingresos: "",
    mensaje: "",
  });

  const cambiar = (e) => {
    setDatos({ ...datos, [e.target.name]: e.target.value });
    setAviso("");
  };

  const validarPaso = () => {
    if (paso === 0) {
      if (!datos.nombre.trim()) return "Escribe tu nombre.";
      if (!/^\S+@\S+\.\S+$/.test(datos.email)) return "Revisa tu correo electrónico.";
    }
    if (paso === 1) {
      if (!datos.telefono.trim()) return "Escribe un número de teléfono.";
      if (!datos.interes) return "Elige sobre qué nos escribes.";
      if (!datos.ingresos) return "Elige el rango de ingresos de tu empresa.";
    }
    if (paso === 2 && !datos.mensaje.trim()) return "Cuéntanos brevemente qué necesitas.";
    return "";
  };

  const siguiente = () => {
    const error = validarPaso();
    if (error) return setAviso(error);
    setPaso(paso + 1);
  };

  const enviar = async (e) => {
    e.preventDefault();
    const error = validarPaso();
    if (error) return setAviso(error);

    setEstado("enviando");
    try {
      const resp = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method: "POST",
        body: JSON.stringify({
          ...datos,
          _subject: "Nuevo mensaje desde caprimtech.com",
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      setEstado(resp.ok ? "enviado" : "error");
    } catch (err) {
      setEstado("error");
    }
  };

  return (
    <>
      <div className="contact-form">
        <div className="container">
          <div className="row gutter-y-30">
            <div className="col-lg-7">
              <div className="contact-form-inner caprim-wizard">
                {estado === "enviado" ? (
                  <div className="caprim-wizard-exito">
                    <h3>Gracias, {datos.nombre.split(" ")[0]}.</h3>
                    <p>
                      Recibimos tu mensaje y te respondemos dentro del siguiente
                      día hábil. Si es urgente, escríbenos por WhatsApp al
                      +57 302 560 7764.
                    </p>
                  </div>
                ) : (
                  <form onSubmit={enviar} noValidate>
                    <p className="caprim-wizard-paso">
                      Paso {paso + 1} de {PASOS.length} · {PASOS[paso].titulo}
                    </p>
                    <h3 className="caprim-wizard-titulo">{PASOS[paso].ayuda}</h3>

                    <div className="caprim-wizard-barra">
                      <span style={{ width: `${((paso + 1) / PASOS.length) * 100}%` }} />
                    </div>

                    {paso === 0 && (
                      <>
                        <div className="inquiry-form-group-one">
                          <label>
                            <i className="fa-regular fa-user" />
                          </label>
                          <input
                            type="text"
                            name="nombre"
                            className="form-control"
                            placeholder="Tu nombre"
                            value={datos.nombre}
                            onChange={cambiar}
                          />
                        </div>
                        <div className="inquiry-form-group-one">
                          <label>
                            <i className="fa-regular fa-envelope" />
                          </label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="nombre@empresa.com"
                            value={datos.email}
                            onChange={cambiar}
                          />
                        </div>
                      </>
                    )}

                    {paso === 1 && (
                      <>
                        <div className="inquiry-form-group-one">
                          <label>
                            <i className="fa-solid fa-phone" />
                          </label>
                          <input
                            type="tel"
                            name="telefono"
                            className="form-control"
                            placeholder="+57 300 000 0000"
                            value={datos.telefono}
                            onChange={cambiar}
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            <i className="fa-solid fa-layer-group" />
                          </label>
                          <select
                            name="interes"
                            className="loan-type"
                            value={datos.interes}
                            onChange={cambiar}
                          >
                            <option value="">¿Sobre qué nos escribes?</option>
                            <option>Dispersión y recaudo de pagos</option>
                            <option>Pagos transfronterizos (Crossborder Payments)</option>
                            <option>Tesorería en la nube</option>
                            <option>Otro</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label>
                            <i className="fa-solid fa-sack-dollar" />
                          </label>
                          <select
                            name="ingresos"
                            className="loan-type"
                            value={datos.ingresos}
                            onChange={cambiar}
                          >
                            <option value="">¿En qué rango están los ingresos mensuales de tu empresa?</option>
                            <option>Entre $0 y $50 millones COP</option>
                            <option>Entre $50 y $500 millones COP</option>
                            <option>Entre $500 y $2.000 millones COP</option>
                            <option>Más de $2.000 millones COP</option>
                          </select>
                        </div>
                      </>
                    )}

                    {paso === 2 && (
                      <div className="inquiry-form-group-one">
                        <label>
                          <i className="fa-solid fa-message" />
                        </label>
                        <textarea
                          name="mensaje"
                          rows={5}
                          className="form-control"
                          placeholder="Cuéntanos en qué podemos ayudarte"
                          value={datos.mensaje}
                          onChange={cambiar}
                        />
                      </div>
                    )}

                    {aviso && <p className="caprim-wizard-aviso">{aviso}</p>}
                    {estado === "error" && (
                      <p className="caprim-wizard-aviso">
                        No pudimos enviar tu mensaje. Escríbenos a{" "}
                        <Link to="mailto:gerencia@caprimtech.com">
                          gerencia@caprimtech.com
                        </Link>
                        .
                      </p>
                    )}

                    <div className="caprim-wizard-botones">
                      {paso > 0 && (
                        <button
                          type="button"
                          className="caprim-btn-atras"
                          onClick={() => setPaso(paso - 1)}
                        >
                          ← Atrás
                        </button>
                      )}
                      {paso < PASOS.length - 1 ? (
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={siguiente}
                        >
                          Siguiente →
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-outline-secondary"
                          disabled={estado === "enviando"}
                        >
                          {estado === "enviando" ? "Enviando…" : "Enviar mensaje"}
                        </button>
                      )}
                    </div>
                  </form>
                )}
              </div>
            </div>

            <div className="col-lg-5">
              <div className="contact-form-right">
                <img
                  src={Contimg01}
                  alt="Caprim · Optimizing global payments for everyone"
                />
                <h4>Lo que pasa después</h4>
                <ul className="caprim-pasos-lista">
                  {SIGUIENTES.map((p) => (
                    <li key={p.n}>
                      <span className="caprim-pasos-num">{p.n}</span>
                      <span>
                        <strong>{p.t}</strong>
                        <em>{p.d}</em>
                      </span>
                    </li>
                  ))}
                </ul>
                <h4>Síguenos</h4>
                <ul className="contact-social-media">
                  <li>
                    <Link to={LINKEDIN} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-linkedin-in" />
                    </Link>
                  </li>
                  <li>
                    <Link to={WHATSAPP} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-whatsapp" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Contact;
